// extracted by mini-css-extract-plugin
export default {"container":"iconComp_container__Uhoby","primary":"iconComp_primary__xlmId","outline":"iconComp_outline__hFxIE"};